export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://i.imgur.com/1VPztJo.jpg" 
          alt="Hotel Jardín Tecina" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 w-full px-6 py-32 text-center text-white">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-light mb-6 leading-tight">
            Hotel Jardín Tecina & Tecina Golf
          </h1>
          <p className="text-2xl md:text-3xl font-light mb-4 text-stone-100">
            Unique by nature (La Gomera)
          </p>
          <div className="w-32 h-1 bg-white/60 mx-auto mb-8"></div>
          <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed text-stone-100">
            Strefa B2B dla polskich agencji: argumenty sprzedażowe, logistyka dojazdu, materiały i szybki kontakt.
          </p>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/60 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
